import { render, staticRenderFns } from "./ClientAppSettings.vue?vue&type=template&id=29b1ba22&scoped=true&"
import script from "./ClientAppSettings.vue?vue&type=script&lang=ts&"
export * from "./ClientAppSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ClientAppSettings.vue?vue&type=style&index=0&id=29b1ba22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b1ba22",
  null
  
)

export default component.exports